

export const UPDATE_DARK_MODE = "UPDATE_DARK_MODE";

interface UpdateDarkModeAction {
    type: typeof UPDATE_DARK_MODE,
    payload: boolean,
}



export type DarkModeActionTypes = UpdateDarkModeAction